import { jsx, jsxs } from "react/jsx-runtime";
const Microsoft = ({ className, size = 32 })=>/*#__PURE__*/ jsxs("svg", {
        className: className,
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        children: [
            /*#__PURE__*/ jsx("path", {
                d: "M11.3958 0.726074H0.726318V11.3956H11.3958V0.726074Z",
                fill: "#F25022"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M23 0.726074H12.3306V11.3956H23V0.726074Z",
                fill: "#7FBA00"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M11.3958 12.3301H0.726318V22.9997H11.3958V12.3301Z",
                fill: "#00A4EF"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M23 12.3301H12.3306V22.9997H23V12.3301Z",
                fill: "#FFB900"
            })
        ]
    });
const logos_Microsoft = Microsoft;
export default logos_Microsoft;
